import { Route, Routes } from "react-router-dom";
import Wrap from "../../hoc/Wrap";
import VisitsList from "./VisitsList";
import EmployeeVisitDetailView from "./EmployeeVisitDetailView";
import EmrVistDetailView from "../EmrProviderContainer/index"
import NewEmrDetailView from "../EmrProviderContainer/NewEmrDetailView";
import { useSelector } from "react-redux";

import NewPatientDetailview from "./NewEmployeeVisitDetailView/NewPatientDetailview";

import VisitsLIstNew from "./NewUIVisitList/VisitsLIstNew";


const EmployeeContainer = () => {
  const isNewUI = useSelector((state) => state.common.isNewUI);
  const EMRDetails=isNewUI?NewEmrDetailView:EmrVistDetailView

  const EmployeeDetailView=isNewUI?NewPatientDetailview:EmployeeVisitDetailView

  const VisitsListPage = isNewUI ? VisitsLIstNew : VisitsList;

  return (
    <Wrap>  
      {/* Other common elements in UserContainer */}
      <Routes>
        <Route path="/visit-details/:visitId/:backTo?" key={1} element={<EmployeeDetailView />}/> 
        <Route path="/" key={0}  element={<VisitsListPage/>} />
        <Route path="/emr-details/:visitId/:backTo?" key={1} element={<EMRDetails />}/>
        {/* <Route path=":filter" key={2}  element={<VisitsList/>} /> */}
      </Routes>
      {/* <Outlet /> */}
  
     
        
    </Wrap>
  );
};






export default EmployeeContainer;
